<template>
    <div class="row justify-content-end">
        <div class="col-auto" id="alert-dismiss">
            <AlertDismiss ref="alertDismiss"></AlertDismiss>
        </div>

        <div class="col-auto">
            <b-button
                v-b-tooltip.hover.bottom="'Cerrar sesión'"
                class="m-2"
                variant="danger"
                @click="onClick"
                :disabled="isLoggingOut"
                id="logout-button"
            >
                <b-icon v-if="!isLoggingOut" icon="door-open-fill"></b-icon>
                <b-spinner v-else small></b-spinner>
             </b-button>
        </div>
    </div>
</template>

<script>

import { mapActions, mapMutations, mapGetters} from 'vuex';
import { remove, localStorageKey } from '@/plugins/localStorage/index.js'
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'

export default {
    data() {
        return {
            isLoggingOut: false
        }
    },
    name: 'Logout-button',

    components: {
        AlertDismiss
    },

    computed: {
        ...mapGetters(["getSession"])
    },
    methods: {
        ...mapActions(["logout"]),
        ...mapMutations(["resetUserState"]),

        async onClick(){
            this.isLoggingOut = true;

            const userId = this.getSession.UserId;

            // in the **very** unlikely event that the user ID is not available, we remove local data
            // the behavior is the same as if the user close the browser without logging out
            if (userId) {
                const result = await this.logout({ id: userId });                    

                if (result.isError) {
                    this.$refs.alertDismiss.showAlert(`Problema al cerrar sesión: ${result.message.substring(0, 50)}`);
                    this.isLoggingOut = false;
                    return;
                }
            }

            remove(localStorageKey.tokenKey);
            remove(localStorageKey.permissionKey);
            remove(localStorageKey.roleKey);    
                
            this.resetUserState();
            this.isLoggingOut = false;
            this.$router.push({ name: "Login" });
        }
    }
}
</script>

<style scoped>
#alert-dismiss {
    position: absolute;
    right: 0;
    top: 125%;
}
#logout-button {
    padding-bottom: 0.47rem;
    padding-top: 0.42rem;
}
</style>